'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

class PayloadMismatchError extends Error {
  constructor(channel, schema, payload) {
    super(`payload does not match the specified schema for channel [${channel}].`);
    this.channel = channel;
    this.schema = schema;
    this.payload = payload;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, PayloadMismatchError);
    }
    this.name = "PayloadMismatchError";
  }
}

exports.PayloadMismatchError = PayloadMismatchError;
